// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Ce4A","resendInfoText":"OnGoingPaymentBox_resendInfoText__3pUUg"};